import React, { createContext, useState, useEffect } from 'react';

import Chart from 'chart.js/auto';


import { prokeyApi } from 'api/prokey';
import './memMonitor.css';

function MemMonitor() {
  const [mem  , setMem  ] = useState([]);
  const [total, setTotal] = useState([]);

  const canvasRef = React.useRef(null);
  const chartRef = React.useRef(null);

  const renderChart = () => { 
    if (!canvasRef.current) return;

    chartRef.current = new Chart(canvasRef.current, {
      type: 'line',
      data: {
        labels: [...Array(100).keys()],
        datasets: [
          // {
          //   label: 'System',
          //   data: mem.system,
          //   // fill: true,
          //   borderColor: 'rgb(190, 100, 150)',
          //   backgroundColor: 'rgba(190, 100, 100,0.5)',
          //   tension: 0.1
          // },
          {
            label: 'RSS',
            data: mem.rss,
            // fill: true,
            borderColor: 'rgb(190, 100, 0)',
            backgroundColor: 'rgba(190, 100, 100,0.5)',
            tension: 0.1
          },
          {
            label: 'Heap Total',
            data: mem.heap_total,
            // fill: true,
            borderColor: 'rgb(0, 100, 75)',
            backgroundColor: 'rgba(190, 100, 100,0.5)',
            tension: 0.1
          },
          {
            label: 'Heap Used',
            data: mem.heap_used,
            // fill: true,
            borderColor: 'rgb(190, 0, 75)',
            backgroundColor: 'rgba(190, 100, 100,0.5)',
            tension: 0.1
          },
        ]
      },
      options:{
        animation: {
          duration: 0
        },
        maintainAspectRatio: false,
        scales : {
            y : {
                min: 0,
                max:  mem.heap_limit,
            }
        }
      }
    })
  }

  const destroyChart = () => {
    if (chartRef.current) {
      chartRef.current.destroy();
      chartRef.current = null;
    }
  };

  useEffect(() => {
    renderChart();

    return () => destroyChart();
  }, [mem]);

  useEffect(()=>{
    const interval = setInterval(() => {
      prokeyApi
        .getResourceMem()
        .then((response) => {
          setMem(response.data);
          setTotal(response.data.total);
        })
        .catch((error) => {
          console.log(error);
        });
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className='memContainer'>    
      <canvas
        ref={canvasRef}
        style={{ minHeight: '400px' }}
      />
    </div>
  );
}

export { MemMonitor };
